import { X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RequiredLabel } from "@/components/catalog/RequiredLabel";

export function JournalTextField({
  id,
  label,
  value,
  onChange,
  invalid,
  describedBy,
  required,
  placeholder,
}: {
  id: string;
  label: string;
  value?: string;
  onChange: (value: string) => void;
  invalid?: boolean;
  describedBy?: string;
  required?: boolean;
  placeholder?: string;
}) {
  return (
    <div>
      <RequiredLabel htmlFor={id} required={required}>
        {label}
      </RequiredLabel>
      <Input
        id={id}
        value={value ?? ""}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="mt-1.5"
        aria-invalid={invalid}
        aria-describedby={describedBy}
      />
    </div>
  );
}

export function JournalPlainTextField({
  id,
  label,
  value,
  onChange,
  placeholder,
}: {
  id: string;
  label: string;
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
}) {
  return (
    <div>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        value={value ?? ""}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="mt-1.5"
      />
    </div>
  );
}

export function JournalNumberField({
  id,
  label,
  value,
  onChange,
  placeholder,
}: {
  id: string;
  label: string;
  value?: number;
  onChange: (value?: number) => void;
  placeholder?: string;
}) {
  return (
    <div>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type="number"
        min="1"
        value={value ?? ""}
        placeholder={placeholder}
        onChange={(event) => {
          if (!event.target.value) {
            onChange(undefined);
            return;
          }
          const parsed = Number.parseInt(event.target.value, 10);
          onChange(Number.isNaN(parsed) ? undefined : parsed);
        }}
        className="mt-1.5"
      />
    </div>
  );
}

export function JournalTagList({
  values,
  onRemove,
}: {
  values: string[];
  onRemove: (index: number) => void;
}) {
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {values.map((value, index) => (
        <span
          key={`${value}-${index}`}
          className="inline-flex items-center gap-1 rounded-full bg-primary/10 px-3 py-1 text-sm text-primary"
        >
          {value}
          <button type="button" onClick={() => onRemove(index)} aria-label={`Remove ${value}`}>
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
    </div>
  );
}
